/**
 * Default manuscript Bible study styles available to every new manuscript.
 */
export const BUILTIN_MARK_STYLES: ManuscriptMarkStyle[] = [
    { id: 'yellow-pencil', name: 'Key Words', color: 'rgb(234, 179, 8)', type: 'highlight', texture: 'pencil', isCustom: false },
    { id: 'green-solid', name: 'Commands', color: 'rgb(34, 197, 94)', type: 'highlight', texture: 'solid', isCustom: false },
    { id: 'purple-marker', name: 'Logical Connectors', color: 'rgb(168, 85, 247)', type: 'circle', texture: 'chalk', thickness: 4, isCustom: false },
    { id: 'blue-underline', name: 'Action Verbs', color: 'rgb(59, 130, 246)', type: 'highlight', texture: 'marker', isCustom: false },
    { id: 'orange-box', name: 'Contrast', color: 'rgb(249, 115, 22)', type: 'box', texture: 'pencil', isCustom: false },
    { id: 'teal-underline', name: 'Questions', color: 'rgb(20, 184, 166)', type: 'double-underline', texture: 'pencil', thickness: 4, isCustom: false },
    { id: 'red-pencil', name: 'Promises', color: 'rgb(239, 68, 68)', type: 'highlight', texture: 'pencil', isCustom: false },
];
